import { SET_SEARCH_TEXT } from "src/actions/type";

const searchReducer = (state = { text: "" }, action) => {
  switch (action.type) {
    case SET_SEARCH_TEXT:
      return { text: action.payload };
    default:
      return state;
  }
};

export default searchReducer;
